import { getLocale } from '../storage/LocaleManager';
import { generateConfig } from '../utils/index';
import { API_URL_CONFIG_TYPE } from '../types';
import {
    SERVICE_MA, SERVICE_EU, SERVICE_UK, SERVICE_AP, SERVICE_US, SERVICE_NE,
    MSCU, MSNA, TBPR,
} from "./constants";

// 退登 区域 appType 映射
export const LOGOUT_TYPE_MAP: Record<string, string> = {
    [SERVICE_EU]: 'eu-region',
    [SERVICE_US]: 'us-region',
    [SERVICE_NE]: 'ne-region',
    [SERVICE_AP]: 'ap-region',
    [SERVICE_MA]: 'ma-region',
    [SERVICE_UK]: 'uk-region',
    // 'home.local.gs-robot.com': 'ap-region', 测试条目
}

// 创建appType的映射，确保logout时，退登到对应的signin页面
export const getLogoutAppType = () => {
    const origin = window.location.hostname;
    // 有映射结果才加入appType，否则走之前的默认行为
    if (LOGOUT_TYPE_MAP[origin]) {
        return `&appType=${LOGOUT_TYPE_MAP[origin]}`;
    }

    return '';
}

// 生成logout全路径 并直接重定向
export const logoutRedirect = () => {
    const { bot } = generateConfig() as API_URL_CONFIG_TYPE;
    const appType = getLogoutAppType();
    const hostname = window.location.hostname;
    // 如果当前是登录网站，存标签页为/complete,调用getById 401退登情况
    if ((hostname.includes('signin'))) {
        window.location.href = `${bot}/gas/api/v1alpha1/sso/logout`;
        return;
    }
    // 退登 不保留hash
    window.location.href = `${bot}/gas/api/v1alpha1/sso/logout?app=${encodeURIComponent(
        window.location.origin + window.location.pathname + '&locale=' + getLocale()
    )}${appType}`;
}

// 生成login全路径 并直接重新登录获取ticket
export const loginRedirect = () => {
    const { bot } = generateConfig() as API_URL_CONFIG_TYPE;
    const appType = getLogoutAppType();
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('locale', getLocale());
    // 登录 需要完整路径
    window.location.href = `${bot}/gas/api/v1alpha1/sso/login?app=${encodeURIComponent(
        `${currentUrl.origin}${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`
    )}${appType}`;
}

// 判断是海外 service-xx.gs-robot.com, signin-xx.gs-robot.com, developer-xx.gs-robot.com
export const getOverseasRegion = () => {
    const env = process.env.REACT_APP_NODE_ENV; // prod
    const domain = window.location.hostname;
    // 非生产 默认是中国
    if (env !== 'prod') {
        return 'CN';
    }
    const SUFFIX = '.gs-robot.com';
    if (!domain.endsWith(SUFFIX)) {
      return ''
    }
  
    const base = domain.slice(0, -SUFFIX.length); // 去掉后缀
    const prefixes = ['service', 'signin', 'developer'];
  
    // 检查是否为 {prefix} 或 {prefix}-ma 形式（即无区域码）
    for (const p of prefixes) {
      if (base === p || base === `${p}-ma`) {
        return 'CN';
      }
    }
  
    // 否则尝试解析为 {prefix}-{region}
    const [prefix, ...rest] = base.split('-');
    if (prefixes.includes(prefix) && rest.length > 0) {
      return rest.join('').toUpperCase();
    }
  
    return '';
}

// 创建region映射，确保请求隐私协议时，传参的region是对应区域
export const getPrivacyDomainRegion = () => {
    const region = process.env.REACT_APP_REGION;

    if (region) {
        // return region.toUpperCase();
        return ''; // 国外可以使用bot.eu.gausium/bot.us.gausium 访问
    }

    return getOverseasRegion();
}

// 针对 service-us.gs-robot.com，service-eu.gs-robot.com 域名下访问，设置endpoint
export const getServiceRegionEndpoint = () => {
    const region = process.env.REACT_APP_REGION;
    if (region) {
        return "";
    }
    const domain = window.location.hostname;
    if (domain.includes('service-us.gs-robot.com')) {
        return MSNA;
    }
    if (domain.includes('service-eu.gs-robot.com')) {
        return MSCU;
    }
    // 后续可能会有针对service-ne 或者 其他国家的 特殊的域名，
    return TBPR;
}